<mat-form-field class="full-width-field">
    <mat-label>Duration</mat-label>
    <mat-select ngModel name="field_duration">
        <mat-option *ngFor="let duration of durations"
            [value]="duration.value">{{duration.value}}</mat-option>
    </mat-select>
</mat-form-field>